const {REACT_APP_HOST} = process.env;

export const HOST = REACT_APP_HOST;
export const HELPER = true;

export const EMAIL_REGEX = /^([0-9a-zA-Z]+[0-9a-z\.\-_]*)(@){1}([0-9a-z]+[a-z0-9\.\-_]+[a-z0-9]+[\.]{1}[a-z]{2,5})$/;
export const USERNAME_REGEX = /([a-zA-Z]+[a-zA-Z0-9\-_\!\.@\$%àèéìòù]*)/;
export const USERNAME_MIN_LEN = 3;
export const PHONE_REGEX = /^(\+){0,1}([0-9]+)(:)*([\s\.\-0-9])+$/;
export const IT_PHONE_REGEX = /^([0-9\+]{1})([0-9\s]{6,})$/;
export const PASSWORD_REGEX = /[0-9]+[a-z]+[A-Z]+/;
export const PWD_MIN_LEN = 6;
export const URL_REGEX = /^([THPWShtpws])+(:\/\/){1}([a-zA-Z0-9\-\+_])+([a-zA-Z0-9\-\+_\/\.])+(:){0,1}([0-9])*([a-zA-Z0-9\-\+_\/\.])+$/;
export const IPv4_REGEX = /^([THPWShtpws]){2,5}(:\/\/){1}([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})(:[0-9]+)*$/;

export const UPPERCASE_AT_LEAST_ONE = /[A-Z]/;
export const LOWERCASE_AT_LEAST_ONE = /[a-z]/;
export const NUMBER_AT_LEAST_ONE = /[0-9]/;
export const SPECIAL_CHARACTER_AT_LEAST_ONE = /[\!@#\*\$\%\^\&\(\)\{\}\[\]\:\;\<\>,\.\?\/\~_\+\-\=\|\\]/;
export const SPACE_CHARACTER_AT_LEAST_ONE = /[\s]+/;

export const SALE_PACK_TYPE = 3;

export const DATE_FORMAT_IT_REGEX = /^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})$/;
export const DATE_FORMAT_IT = "DD/MM/YYYY";
export const DATETIME_FORMAT_IT = "DD/MM/YYYY HH:mm:ss";
export const ESOLVER_DATE_FORMAT = "YYYY-MM-DD";
export const DATETIME_ISO_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const DATE_ISO_FORMAT = "YYYY-MM-DDT00:00:00";
export const SERVICE_DATE_FORMAT_IT = "YYYY-MM-DD";
export const CALENDAR_DATE_FORMAT_IT = "dd/MM/yyyy";
export const CALENDAR_MOMENT_DATE_FORMAT_IT = "DD-MM-YYYY";
export const CALENDAR_MOMENT_DATE_FORMAT_YEARS = "YYYY-MM-DD";
export const MOMENT_JS_DATE_FORMAT_WORDS_IT = "LL";
export const FLOAT_NUMBER_REGEX = /^[-+]?[0-9]*\.?[0-9]*$/;
export const MAX_UPLOADING_FILE_SIZE = 25000000;
export const SIRATING_SERVICE_NAME = "SiRating";
export const MOMENT_JS_INVALID_DATE_MSG = "Invalid date";
export const START_MODERN_ISO_TIME = "1970-01-01T00:00:00.0";
export const HTTP_CALL_SECONDS_WAIT_ALLOWED = 180;
export const MAX_FILE_NAME_LENGTH = 30;
export const ITEM_PER_PAGE = 256;
